import Vue from 'vue';
import wb from '../registerServiceWorker';

Vue.prototype.$workbox = wb;
